import {Dictionary} from './Dictionary'
import {OffsetLimit} from './OffsetLimit'

export interface M {
    readonly itemsPerPage: number
    readonly currentPage: number
}

export function toOffsetLimit(
    {currentPage, itemsPerPage}: M
): OffsetLimit {
    return {
        offset: (currentPage - 1) * itemsPerPage,
        limit: itemsPerPage,
    }
}

export function toQueryParameters(
    {currentPage, itemsPerPage}: M,
): Dictionary<string> {
    return {
        page: currentPage.toString(),
        itemsPerPage: itemsPerPage.toString(),
    }
}

export function fromQueryParamters(
    defaultItemsPerPage: number,
    parameters: Dictionary<string>,
): M {
    return {
        itemsPerPage:
            typeof parameters.itemsPerPage !== 'undefined'
                ? parseInt(parameters.itemsPerPage, 10)
                : defaultItemsPerPage,
        currentPage:
            typeof parameters.page !== 'undefined'
                ? parseInt(parameters.page, 10)
                : 1,
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/PageSection.ts